<template>
    <div class="container body fix-footer">
        <div class="row justify-content-center">
            <div class="col-md-8 mt-5 mb-3">
                <div class="card">
                    <div class="card-header">
                        <h3>{{$t('pages.NewPage')}}</h3>
                    </div>
                    <div class="card-body">
                        <div class="alert alert-danger" v-if="error">
                            {{$t(error)}}
                        </div>
                        <form @submit="submit">
                            <formly-form :form="form" :model="model" :fields="fields" ref="createPage"/>
                            <button type="submit" class="btn btn-primary">{{ $t('button.Save') }}</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import isInt from 'validator/lib/isInt';
  import isLength from 'validator/lib/isLength';
  import { mapActions } from 'vuex';
  import {ERROR_MESSAGES, ROUTER_NAMES} from '../../constants';

  export default {
    name: 'CreatePage',
    data() {
      return {
        error: '',
        form: {},
        model: {
          title: '',
          body: '',
          short: '',
          status: 'published',
        },
        fields: [
          {
            key: 'title',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.Title')
            },
            required: true,
            validators: {
              validTitle: {
                expression(field, model, next) {
                  next(isLength(model[field.key], { min: 3 }));
                },
                message: 'Nazov musi obsahovat aspoň 3 znaky'
              }
            }
          },
          {
            key: 'body',
            type: 'mce',
            templateOptions: {
              label: this.$t('fields.Content'),
            },
            required: true,
            validators: {
              validShort: {
                expression(field, model, next) {
                  next(isLength(model[field.key], {
                    min: 10
                  }));
                },
                message: this.$tc('validation.min', 10)
              }
            }
          },
          {
            key: 'order',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.Order'),
              inputType: 'number'
            },
            validators: {
              validShort: {
                expression(field, model, next) {
                  next(isInt(model[field.key]));
                },
                message: this.$tc('validation.int', 10)
              },
            },
            required: true,
          }
        ]
      };
    },
    methods: {
      ...mapActions(['createPage', 'loadPages']),
      submit(e) {
        e.preventDefault();

        this.$refs.createPage.validate()
          .then(() => {
            if (!this.form.$valid) return;

            this.createPage({
              ...this.model,
              parent_slug: this.$route.params.parentSlug,
              active: true
            })
              .then((response) => {
                // TODO: fix this better way
                return this.loadPages().then(() => {
                  this.$router.push({
                    name: ROUTER_NAMES.PARENT_PAGE,
                    params: {
                      parent: this.$route.params.parentSlug
                    }
                  });
                });
              })
              .catch((e) => {
                this.error = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
              });
          });
      }
    }
  };
</script>

<style scoped>

</style>
